import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { isAnswered } from "../../../../utils/QuestionUtils";
import QuestionHeader from "./QuestionHeader";
import TextRenderer from "./renderer/TextRenderer";

/**
 * Text question component for survey-view.
 */
const TextQuestion = ({ disabled, question, questionAnswer, setQuestionAnswer, validation }) => {
  const answered = isAnswered(question, questionAnswer);
  return (
    <Row>
      <Col lg={12} md={12} sm={12}>
        <QuestionHeader
          showOnlyError
          question={question}
          answered={answered}
          validation={validation}
        >
          <Row>
            {question.type === "infoMessage" ? null : (
              <Col md={12}>
                <TextRenderer
                  disabled={disabled}
                  question={question}
                  collection={questionAnswer.answers}
                  setQuestionAnswer={setQuestionAnswer}
                  validation={validation}
                  isIncomplete={!answered && question.isRequired}
                />
              </Col>
            )}
          </Row>
        </QuestionHeader>
      </Col>
    </Row>
  );
};

TextQuestion.propTypes = {
  disabled: PropTypes.bool,
  question: PropTypes.object,
  questionAnswer: PropTypes.object,
  setQuestionAnswer: PropTypes.func,
  validation: PropTypes.array
};

export default TextQuestion;
